var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.StatusChip,{attrs:{"type":"manday","status":_setup.statusValue}},[_vm._v(_vm._s(_setup.statusRep))])
}
var staticRenderFns = []

export { render, staticRenderFns }